<template>
  <component
    :is="isDesktopFormLayout ? 'CustomerFormDesktopBridge' : 'CustomerFormMobile'"
  />
</template>
<script>
import Description from "../../components/general/description/Description";
import aicomplete from "../../components/general/AIcomplete/index";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
import FormAttachmentDoc from "../../components/general/FormAttachmentDoc";
import customFields from "../../components/general/customFields/index.vue";
import FlexibleAutocomplete from "../../components/general/patial/FlexibleAutocomplete.vue";
import CustomerFormDesktopBridge from "./layouts/desktop/CustomerFormDesktopBridge.vue";
import CustomerFormMobile from "./layouts/mobile/CustomerFormMobile.vue";

const CUSTOMER_DESKTOP_MIN_WIDTH = 800;

export default {
  name: "Customer",
  provide() {
    return {
      customerForm: this,
    };
  },
  components: {
    CustomerFormDesktopBridge,
    CustomerFormMobile,
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    FlexibleAutocomplete,
    Description,
    customFields,
    filePicker,
    FormAttachmentDoc,
    aicomplete,
  },
  mixins: [General],
  props: ["idProp", "returnObject"],
  data: () => ({
    SMSBRANCH: null,
    activeTab: null,
    webziSeller: null,
    webziSellerCommission: null,
    investorSellPercent: null,
    investorReturnSellPercent: null,
    visitorReturnSellPercent: null,
    panel: [5],
    panelPersonnely: null,
    personnelType: "personnel",
    departmentAccess: null,
    customFields: null,
    attachments: null,
    deactiveBranchAccess: null,
    visitorSellPercent: null,
    reload: true,
    valid: true,
    gender: "man",
    showPassword: false,
    deactiveChangeSellPrice: false,
    branchAccess: null,
    imagePicker: null,
    imagePickerVal: null,
    portalId: null,
    student: null,
    teacher: null,
    investor: null,
    visitor: null,
    translator: null,
    personnel: null,
    woocommerceId: null,
    woocommerceIdItems: [],
    sazitoId: null,
    magnetId: null,
    webziId: null,
    digikalaId: null,
    role: null,
    admin: null,
    plan: null,
    category: null,
    entrepotAccess: null,
    initialCheck: true,
    username: null,
    avatar: null,
    password: null,
    tag: null,
    type: null,
    attractionMethod: null,
    lead: null,
    mobile: null,
    personel: null,
    status: "active",
    nationalCode: null,
    content: null,
    firstname: null,
    birthDate: null,
    lastname: null,
    postalCode: null,
    currency: null,
    businessName: null,
    //add
    statePlaceofBirth: null,
    cityPlaceofBirth: null,
    fathersName: null,
    BirthCertificateNumber: null,
    dateOfBirthCertificate: null,
    statePlaceOfBirthCertificate: null,
    cityPlaceOfBirthCertificate: null,
    education_field: null,
    childCount: null,
    insurance_job_position: null,
    insurance_type: null,
    InsurerName: null,
    InsurerNumber: null,
    InsurerRecordToMonth: null,
    personnelCode: null,
    workshop: null,
    finance_job_position: null,
    startToWork: null,
    EndToWork: null,
    bankName: null,
    SalaryAccountNumber: null,
    type_of_employment: null,
    type_of_contract: null,
    soldier_status: null,
    job_field: null,
    ServicePlace: null,
    soldier_location_type: null,
    exemption_type: null,
    magor: null,
    married: false,
    hrm_id: null,
    personnely: false,
    currencyId: "",
    //
    financialCode: null,
    phone: null,
    render: true,
    accountCategory: null,
    isLoading: false,
    country: null,
    state: null,
    stateWatch: false,
    countWoocommercepanel: 1,
    city: null,
    cityWatch: false,
    email: null,
    id: null,
    address: null,
    nature_initial_price: null,
    natureItems: null,
    initial_price: null,
    bank: null,
    /* userFinancialAccess: {
        bank_cash: {
          id: []
        }
      }, */
    options: {
      locale: "en-US",
      prefix: "",
      suffix: " ",
      precision: 0,
    },
    custom_code: null,
    panelBranch: null,
    optionsApi: {
      page: 1,
      itemsPerPage: 500,
    },
    branchesItems: null,
    smsTree: [],
    treeItems: null,
    isUserRepitetive: null,
    userFullName: null,
    customerBranch: null,
    customerTaxCodeBranch: null,
    configs: {
      showInStockProduct: null,
    },
    personelStatus: null,
  }),
  computed: {
    isDesktopFormLayout() {
      // Embedded dialogs/autocomplete stay on desktop shell.
      if (this.idProp != null || this.returnObject) return true;
      return this.$vuetify.breakpoint.width >= CUSTOMER_DESKTOP_MIN_WIDTH;
    },
    personType: {
      get() {
        return this.gender === "company" ? "company" : "real";
      },
      set(val) {
        if (val === "company") {
          this.gender = "company";
        } else if (this.gender === "company") {
          this.gender = "man";
        }
      },
    },
    personnelyConditionRule() {
      return (v) => {
        if (this.personnely === "active") {
          return !!v || this.$t("is-required");
        }
        return true;
      };
    },
    personnelyTabIndex() {
      if (!this.personnely) return null;
      let index = 1;
      if (this.activeUser) index++;
      index++;
      index++;
      if (this.activeUser && this.branchesItems != null) index++;
      return index;
    },
    isSupport() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        return (
          Number(
            token &&
              token.init &&
              token.init.appBarsOpacity &&
              token.init.appBarsOpacity.abr
          ) === 83
        );
      } catch (e) {
        return false;
      }
    },
    activeUser() {
      var active = false;
      if (
        this.$store.state.permissions &&
        this.$store.state.permissions.includes("usersList") &&
        (this.student === "active" ||
          this.teacher === "active" ||
          this.translator === "active" ||
          this.personel)
      ) {
        active = true;
      }
      return active;
    },
  },
  watch: {
    personnelStatus: {
      handler(val) {
        if (val == "active") {
          this.personel = "active";
        }
      },
      deep: true,
      immediate: true,
    },

    activeTab(val) {
      if (val) {
        if (val == 4) {
          if (this.SMSBRANCH != null && this.SMSBRANCH.length > 0) {
            const apiBranchItems = this.SMSBRANCH;
            this.branchesItems =
              apiBranchItems != null && apiBranchItems.length > 0
                ? (this.branchesItems = this.branchesItems?.map((branch) => {
                    const match = apiBranchItems.find((b) => b.id == branch.id);
                    return {
                      ...branch,
                      smsTree: match ? match.smsTree : [],
                    };
                  }))
                : this.branchesItems;
          }
        }
      }
    },
    idProp() {
      this.render = true;
      if (this.idProp != null) {
        this.id = this.idProp;
        this.show();
        this.render = false;
      } else {
        this.render = false;
      }
    },
    initial_price(val) {
      if (val && parseFloat(val) > 0 && !this.nature) {
        this.nature = "debtor";
      }
    },
    avatar() {},
    branchesItems: {
      handler(newValue) {
        const simplified = newValue?.map((b) => ({
          id: b.id,
          name: b.name,
          smsTree: b.smsTree,
        }));
        if (JSON.stringify(this.branchesItems) !== JSON.stringify(simplified)) {
          this.branchesItems = simplified;
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    if (this.$route.params.id != null) {
      this.id = this.$route.params.id;
      this.show();
      this.render = false;
    }
    if (this.idProp != null) {
      this.id = this.idProp;
      this.show();
      this.render = false;
    }
    if (!this.id && this.$route?.query?.fromPersonnel === "1") {
      this.personnely = "active";
    }
  },
  mounted() {
    if (!this.id) {
      this.username = null;
      this.password = null;
    }
    this.fetchItemsForSMS();
    this.fetchBranchesForSMS();

    if (this.woocommerceIdItems.length === 0) {
      this.addWoocommerceIdItems();
    }
    this.natureItems = [
      {
        value: "debtor",
        text: this.$t("debtor"),
      },
      {
        value: "creditor",
        text: this.$t("creditor"),
      },
    ];
  },
  methods: {
    openExpansionPanel(index) {
      const current = Array.isArray(this.panel) ? this.panel : [];
      if (!current.includes(index)) {
        this.panel = [...current, index];
      }
    },
    shouldOpenIdentityPanel() {
      const IDENTITY_PANEL_INDEX = 2;
      const personnelyIdentityFields = [
        "birthDate",
        "fathersName",
        "BirthCertificateNumber",
        "dateOfBirthCertificate",
      ];

      if (this.personnely === "active") {
        const hasMissingField = personnelyIdentityFields.some((field) => !this[field]);
        if (hasMissingField) {
          return IDENTITY_PANEL_INDEX;
        }
      }

      return null;
    },
    showWorkshopSnackbar() {
      this.snakbarText = this.$t("please-select-workshop");
      this.snakbarColor = "red";
      this.snakbar = true;
    },
    showComplateMainInfoSnackbar() {
      this.snakbarText = this.$t("complete-main-info-before-personnely");
      this.snakbarColor = "red";
      this.snakbar = true;
    },
    validateIdentityFields() {
      const fieldRefs = [
        "refBirthDate",
        "refFathersName",
        "refBirthCertificateNumber",
        "refDateOfBirthCertificate",
      ];

      fieldRefs.forEach((refName) => {
        const field = this.$refs[refName];
        if (field && typeof field.validate === "function") {
          field.validate(true);
        }
      });
    },
    runFormValidation() {
      this.validateIdentityFields();
      return this.$refs.form.validate();
    },
    fetchApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        key: payload.type,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "hrm/get-config", { params })
        .then(function (response) {
          let list = response && response.data ? response.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    fetchWorkshopApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "workshop", { params })
        .then(function (response) {
          let list = response && response.data.data ? response.data.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    checkUser() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .get(this.$endpointI + "user/check-user-exist", {
          params: {
            mobile: app.username,
          },
        })
        .then((res) => {
          app.isUserRepitetive = res.data.data;
          if (app.isUserRepitetive != null) {
            app.snakbarText = app.$t("this user is repitetive");
            app.snakbarColor = "green";
            app.snakbar = true;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addWoocommerceIdItems() {
      if (
        this.$store.state.allConfig &&
        this.$store.state.allConfig.countWoocommercePanel
      ) {
        this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel;
      }
      if (this.woocommerceIdItems.length < this.countWoocommercepanel) {
        var item = {
          woocommercePanelName: null,
          woocommerceId: null,
        };
        this.woocommerceIdItems.push(item);
      }
    },
    removeWoocommerceId(item) {
      var i = this.woocommerceIdItems.indexOf(item);
      this.woocommerceIdItems.splice(i, 1);
    },
    cancel() {
      if (!this.idProp && !this.returnObject) {
        // this.$store.commit("REMOVE_COMPONENTS", {
        //   path: this.$route.path,
        //   name: this.$route.name,
        //   query: { ...this.$route.query },
        //   params: { ...this.$route.params },
        // });
        if (this.lead === "active") {
          this.goTo("leadList");
        } else {
          if (this.personel === "active") {
            this.goTo("usersList");
          } else {
            this.goTo("customerList");
          }
        }
      } else {
        this.$emit("close");
      }
    },
    create() {
      var app = this;
      app.isLoading = true;

      const identityPanelIndex = this.shouldOpenIdentityPanel();
      if (identityPanelIndex !== null) {
        this.openExpansionPanel(identityPanelIndex);
      }

      this.$nextTick(() => {
        this.$nextTick(() => {
          const isFormValid = app.runFormValidation();
          const needsWorkshop = app.personnely === "active" && !app.workshop;

          if (
            this.personnelyTabIndex !== null &&
            this.activeTab === this.personnelyTabIndex
          ) {
            console.log(identityPanelIndex, "identityPanelIndex");
            if (identityPanelIndex !== null) {
              app.showComplateMainInfoSnackbar();
              app.isLoading = false;
              return;
            } else if (identityPanelIndex == null && needsWorkshop) {
              app.showWorkshopSnackbar();
              app.isLoading = false;
              return;
            }
          }
          if (!isFormValid) {
            if (needsWorkshop) {
              app.showWorkshopSnackbar();
            }
            app.isLoading = false;
            return;
          }

          if (needsWorkshop) {
            app.showWorkshopSnackbar();
            app.isLoading = false;
            return;
          }
          if (!app.firstname || !String(app.firstname).trim()) {
            app.activeTab = 0;
            app.snakbarText = `${app.$t("name")} ${app.$t("is-required")}`;
            app.snakbarColor = "red";
            app.snakbar = true;
            app.isLoading = false;
            return;
          }
          app.$axios
            .post(this.$endpoint + "customer", this.$data)
            .then((res) => {
              app.snakbarText = app.$t("registered");
              app.snakbarColor = "green";
              app.snakbar = true;
              if (app.imagePicker) {
                app.$refs.refFilePicker.create(res.data.data.id);
              }
              if (app.$refs.refFilePickerDocument !== undefined && app.attachments) {
                app.$refs.refFilePickerDocument.create(res.data.data.id);
              }
              app.$emit("input", res.data.data);
              app.clearForm();
              app.cancel();
            })
            .catch((err) => {
              this.isLoading = false;
              if (err.response && err.response.status === 409) {
                this.$store.commit("SET_PLAN_DIALOG", true);
              }
              this.serverErrorHandeler(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        });
      });
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "customer/" + this.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data || null;
            app.hrm_id = res?.hrm_employee?.id || null;
            //true check box personnely
            if (app.hrm_id != null) {
              app.personnely = "active";
            } else {
              app.personnely = null;
            }
            //add showInStockProduct value checkbox
            if (res.configs) {
              app.configs.showInStockProduct = res.configs.value ?? null;
            }
            app.id = res.id;
            app.country = res.country;
            app.address = res.address;
            app.attachments = res.attachments;
            app.state = res.state;
            app.city = res.city;
            app.imagePicker = res.avatar;
            app.customFields = res.custom_fields;
            app.imagePickerVal = res.avatar;
            app.content = res.content;
            app.firstname = res.firstname;
            app.lastname = res.lastname;
            app.gender = res.gender;
            app.status = res.status;
            app.branch = res.meta ? res.meta.branch : null;
            app.personel = res.personel;
            app.personnelType = res.personnelType;
            app.departmentAccess =
              res.department_access.length != 0 ? res.department_access : null;
            app.category = res.category;
            app.lead = res.lead;
            app.email = res.email;
            app.phone = res.phone;
            app.mobile = res.mobile;
            app.plan = res.plan ? res.plan.plan : null;
            app.birthDate = res.birth_date;
            app.admin = res.admin;
            app.branchAccess = res.branchAccess.length != 0 ? res.branchAccess : null;
            app.entrepotAccess =
              res.entrepotAccess.length != 0 ? res.entrepotAccess : null;
            app.nationalCode = res.national_code;
            app.financialCode = res.financial_code;
            app.businessName = res.business_name;
            app.postalCode = res.postal_code;
            app.initialCheck = res.initialCheck;
            app.attractionMethod = res.attraction_method;
            app.nature_initial_price = res.nature_initial_price;
            app.initial_price = res.initial_price;
            app.bank =
              res.user_financial.length != 0
                ? res.user_financial.map((item) => item.bank)
                : null;
            app.role = res.role;
            app.username = res.username;
            app.custom_code = res.fin.custom_code;
            app.portalId = res.integrator.portalId;
            app.woocommerceIdItems = res.woocommerceIdItems;
            app.sazitoId = res.integrator.sazitoId;
            app.magnetId = res.integrator.magnetId;
            app.webziId = res.integrator.webziId;
            app.webziSeller = res.integrator.webziSeller;
            app.webziSellerCommission = res.integrator.webziSellerCommission;
            app.digikalaId = res.integrator.digikalaId;
            app.deactiveChangeSellPrice = res.integrator
              ? res.integrator.deactiveChangeSellPrice
              : null;
            app.deactiveBranchAccess = res.integrator
              ? res.integrator.deactiveBranchAccess
              : null;
            app.student = res.integrator ? res.integrator.student : null;
            app.teacher = res.integrator ? res.integrator.teacher : null;
            app.visitor = res.integrator ? res.integrator.visitor : null;
            app.investor = res.integrator ? res.integrator.investor : null;
            app.visitorSellPercent = res.integrator
              ? res.integrator.visitorSellPercent
              : null;
            app.visitorReturnSellPercent = res.integrator
              ? res.integrator.visitorReturnSellPercent
              : null;
            app.investorSellPercent = res.integrator
              ? res.integrator.investorSellPercent
              : null;
            app.investorReturnSellPercent = res.integrator
              ? res.integrator.investorReturnSellPercent
              : null;
            app.translator = res.integrator ? res.integrator.translator : null;
            app.SMSBRANCH = res.branchesItems;
            //add
            app.statePlaceofBirth = res?.hrm_employee?.state_place_birth || null;
            app.cityPlaceofBirth = res?.hrm_employee?.city_place_birth || null;
            app.fathersName = res?.hrm_employee?.fathers_name || null;
            app.BirthCertificateNumber =
              res?.hrm_employee?.birth_certificate_number || null;
            app.dateOfBirthCertificate =
              res?.hrm_employee?.date_of_birth_certificate || null;
            app.statePlaceOfBirthCertificate =
              res?.hrm_employee?.state_place_birth_certificate || null;
            app.cityPlaceOfBirthCertificate =
              res?.hrm_employee?.city_place_birth_certificate || null;
            app.education_field = res?.hrm_employee?.education_field || null;
            app.childCount = res?.hrm_employee?.child_count || null;
            app.insurance_job_position =
              res?.hrm_employee?.insurance_job_position || null;
            app.insurance_type = res?.hrm_employee?.insurance_type || null;
            app.InsurerName = res?.hrm_employee?.insurer_name || null;
            app.InsurerNumber = res?.hrm_employee?.insurer_number || null;
            app.InsurerRecordToMonth = res?.hrm_employee?.insurer_record_to_month || null;
            app.personnelCode = res?.hrm_employee?.personnel_code || null;
            app.workshop = res?.hrm_employee?.workshop || null;
            app.finance_job_position = res?.hrm_employee?.finance_job_position || null;
            app.startToWork = res?.hrm_employee?.start_to_work || null;
            app.EndToWork = res?.hrm_employee?.end_to_work || null;
            app.bankName = res?.hrm_employee?.bank_name || null;
            app.SalaryAccountNumber = res?.hrm_employee?.salary_account_number || null;
            app.type_of_employment = res?.hrm_employee?.type_of_employment || null;
            app.type_of_contract = res?.hrm_employee?.type_of_contract || null;
            app.soldier_status = res?.hrm_employee?.soldier_status || null;
            app.job_field = res?.hrm_employee?.job_field || null;
            app.ServicePlace = res?.hrm_employee?.service_place || null;
            app.soldier_location_type = res?.hrm_employee?.soldier_location_type || null;
            app.exemption_type = res?.hrm_employee?.exemption_type || null;
            app.magor = res?.hrm_employee?.magor || null;
            app.married = res?.hrm_employee?.married || false;
            app.customerBranch = res.meta?.customer_branch;
            app.customerTaxCodeBranch = res.meta?.customer_tax_code_branch;
            if (res.tags) {
              app.tag = res.tags;
              app.more = true;
            }
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    update() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .put(this.$endpoint + "customer/" + this.id, this.$data)
        .then((res) => {
          res = res.data;
          app.$emit("close", app.$route);
          if (app.imagePicker) {
            app.$refs.refFilePicker.create(app.id);
          }
          if (app.$refs.refFilePickerDocument !== undefined) {
            app.$refs.refFilePickerDocument.create(app.id);
          }
          app.cancel();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    clearForm() {
      this.valid = true;
      this.gender = "man";
      this.showPassword = false;
      this.attachments = null;
      this.role = null;
      this.category = null;
      this.username = null;
      this.avatar = null;
      this.password = null;
      this.tag = null;
      this.type = null;
      this.attractionMethod = null;
      this.lead = null;
      this.mobile = null;
      this.personel = null;
      this.status = "active";
      this.nationalCode = null;
      this.content = null;
      this.firstname = null;
      this.birthDate = null;
      this.lastname = null;
      this.postalCode = null;
      this.currency = null;
      this.businessName = null;
      this.financialCode = null;
      this.phone = null;
      this.accountCategory = null;
      this.isLoading = false;
      this.country = null;
      this.state = null;
      this.stateWatch = false;
      this.city = null;
      this.cityWatch = false;
      this.email = null;
      this.id = null;
      this.address = null;
      this.nature_initial_price = null;
      this.initial_price = null;
      this.custom_code = null;
      // this.treeItems = null
      // this.branchesItems = null
      // this.smsTree = null
    },
    fetchItemsForSMS() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getSmsTemplate",
          },
        })
        .then((res) => {
          const data = res.data;
          const keys = Object.keys(data);
          const treeItems = keys.map((moduleKey) => {
            return {
              id: moduleKey,
              module: moduleKey,
              name: this.$t(moduleKey),
              children: data[moduleKey].map((item) => ({
                id: item.id,
                name: this.$t(item.name),
              })),
            };
          });
          this.treeItems = treeItems;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(function () {});
    },
    fetchBranchesForSMS() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "branch/list", {
          params: {
            type: "all",
            options: app.optionsApi,
          },
        })
        .then((res) => {
          const list = res.data.data || [];
          // Always include whole system item at top
          const wholeSystem = { id: 0, name: this.$t("whole-system"), smsTree: [] };
          if (list.length > 0) {
            this.branchesItems = [
              wholeSystem,
              ...list.map((branch) => ({
                ...branch,
                smsTree: [],
              })),
            ];
          } else {
            this.branchesItems = [wholeSystem];
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(function () {});
    },
  },
};
</script>

